
<template>
  <section class="section pb-0 section-components" id="road-map">
    <div class="py-5 bg-secondary">
      <div class="container">
        <h2 class="mb-3">
          <span>Roadmap</span>
        </h2>
        <Timeline />
      </div>
    </div>
  </section>
</template>
<script>
import Timeline from "./Timeline";

export default {
  components: {
    Timeline,
  },
};
</script>
<style>
.timeline__item::after {
  -webkit-box-sizing: unset !important;
  box-sizing: unset !important;
  /* z-index: 0 !important; */
  top: calc(50% - 19px) !important;
}
.timeline__item::before {
  -webkit-box-sizing: unset !important;
  box-sizing: unset !important;
  z-index: 0 !important;
  top: 48% !important;
}
</style>
